import * as React from 'react';
import axios from 'axios';
import { Chart as ChartJS } from 'chart.js';
import { ChartDataContext, ChartData } from "./Chart";
import { FormContext, FormData } from "./Form";

export type ChartRefsAction = AddChartRefAction | DownloadPdfAction | DownloadingPdfAction | DownloadedPdfAction | ResetPdfDownloadAction;

export type ManageableChartRefs = [ChartRefs, React.Dispatch<ChartRefsAction>];

export type AddChartRefAction = {
    type: 'ADDCHARTREF';
    payload: {
        chartref: ChartRef;
    };
};

export type DownloadPdfAction = {
    type: 'DOWNLOADPDF';
    payload: {};
};

export type DownloadingPdfAction = {
    type: 'DOWNLOADINGPDF';
    payload: {};
};

export type ResetPdfDownloadAction = {
    type: 'RESETPDFDOWNLOD';
    payload: {};
};

export type DownloadedPdfAction = {
    type: 'DOWNLOADEDPDF';
    payload: {
        pdfUri: string;
    };
};

export type ChartRef = {
    ref: ChartJS<'bar'> | null;
    label: string;
}

export type ChartRefs = {
    chartrefs: Array<ChartRef>;
    pdfUri: string;
    download: boolean;
    downloading: boolean;
}

export const ChartRefContext: React.Context<ManageableChartRefs> = React.createContext<ManageableChartRefs>([
    initialState(),
    (): void => undefined,
]);


type ChartRefsDataProps = {
    children: React.ReactNode;
    ajaxUrl: string;
    nonce: string;
};


function chartRefsReducer(data: ChartRefs, action: ChartRefsAction): ChartRefs {
    switch (action.type) {
        case 'ADDCHARTREF':
            let newData = {
                ...data
            };
            newData.chartrefs.push(action.payload.chartref)
            return newData;
        case 'DOWNLOADPDF':
            return {
                ...data,
                download: true
            };
        case 'DOWNLOADINGPDF':
            return {
                ...data,
                downloading: true
            };
        case 'DOWNLOADEDPDF':
            return {
                ...data,
                pdfUri: action.payload.pdfUri,
                download: false,
                downloading: false
            };
        case 'RESETPDFDOWNLOD':
            return {
                ...data,
                pdfUri: ''
            };
        default:
            return data;
    }
}

function initialState(): ChartRefs {
    return {
        chartrefs: [],
        pdfUri: '',
        download: false,
        downloading: false
    };
}

type PostData = {
    charts: Array<{
        label: string;
        image?: string;
    }>;
    id: string;
    filters: FormData;
    stats: ChartData;
    nonce:string;
}

export function ChartRefsDataProvider(props: ChartRefsDataProps): JSX.Element {
    const [chartData,] = React.useContext(ChartDataContext);
    const [formData,] = React.useContext(FormContext);
    const [chartRefsdata, dispatch] = React.useReducer(
        chartRefsReducer,
        initialState(),
    );

    React.useEffect((): void => {
        const post: PostData = {
            charts: chartRefsdata.chartrefs.map((chart) => {
                return {
                    label: chart.label,
                    image: chart.ref?.canvas?.toDataURL()
                }
            }),
            id: formData.scan_id,
            filters: formData,
            stats: chartData,
            nonce: props.nonce
        };

        if (!chartRefsdata.downloading) {

            if (chartRefsdata.download) {
                dispatch({type: 'DOWNLOADINGPDF', payload: {}});

                axios
                    .post(
                        props.ajaxUrl + '?action=zmpzt_persona_scan_get_advanced_stats_pdf',
                        post,
                    )
                    .then((res): void => {
                        if (res.data.url===undefined) {
                            return;
                        }
                        dispatch({type: 'DOWNLOADEDPDF', payload: {pdfUri: res.data.url}});
                    });

            }

        }
    }, [chartRefsdata]);

    return (
        <ChartRefContext.Provider value={[chartRefsdata, dispatch]}>
            {props.children}
        </ChartRefContext.Provider>
    );
}
